import {Pipe, PipeTransform} from '@angular/core'
import {Language} from '../../core/i18n/language'
import {TranslocoService} from '@ngneat/transloco'

export const agencyNamePrefixesByLanguage: Record<Language, string> = {
  en: 'Mobiliar Generalagentur',
  fr: 'Agence générale de la Mobilière',
  it: 'Mobiliar Generalagentur',
  de: 'Mobiliar Generalagentur',
}

@Pipe({
  name: 'bgoRemoveAgencyPrefixPipe',
})
export class RemoveAgencyPrefixPipe implements PipeTransform {
  private readonly exclutionStrings = agencyNamePrefixesByLanguage

  transform(value: string): string {
    const exclutionString = this.exclutionStrings[this.translationService.getActiveLang()]
    return value.replace(exclutionString, '').trim()
  }

  constructor(private readonly translationService: TranslocoService) {}
}
